import {
  ISendProviderInquiryRequest,
  SendProviderInquiryRequest,
  SendProviderInquiryResponse,
  space
} from "../../provider_api";
import {useRpcSender} from "../RpcSender";
import {RpcState} from "../RpcState";
import {useState} from "react";
import IErrorProto = space.kenko.proto.IErrorProto;

export const useSendProviderInquiry = () => {

  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});
  const [errors, setErrors] = useState<IErrorProto[]>([]);

  const send = (props: { request: ISendProviderInquiryRequest, onSuccess: () => void }) => {

    setRpcState({state: 'pending'});
    setErrors([]);
    rpcSender.send('send_provider_inquiry',
        SendProviderInquiryRequest.encode(props.request).finish())
        .then(value => {
          const response = SendProviderInquiryResponse.decode(value);
          if (response.okay) {
            setRpcState({state: 'success'});
            props.onSuccess();
          } else {
            setErrors(response.errors);
            setRpcState({state: 'error'});
          }
        }).catch(e => {
      setRpcState({state: 'error'});
    });
  }

  return {send, rpcState, errors};
}